type PixelEventParams = {
    content_name?: string;
    content_category?: string;
    content_ids?: string[];
    content_type?: string;
    value?: number;
    currency?: string;
    [key: string]: any;
};

const PIXEL_ID = import.meta.env.VITE_FACEBOOK_PIXEL_ID || '2097330251107551';

export const initPixel = () => {
    if (typeof window === 'undefined') return;

    // Prevent multiple initializations
    if ((window as any).fbq) return;

    const f = window as any;
    if (f.fbq) return;

    const n = (f.fbq = function (...args: any[]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const func = n as any;
        func.callMethod ? func.callMethod.apply(func, args) : func.queue.push(args);
    });

    const nAny = n as any;
    if (!f._fbq) f._fbq = n;
    nAny.push = n;
    nAny.loaded = true;
    nAny.version = '2.0';
    nAny.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
};

export const trackPixelEvent = (eventName: string, params?: PixelEventParams) => {
    // Debug log to verify what is actually being sent by the code
    if (typeof window !== 'undefined') {
        console.log('[Pixel] Tracking event:', eventName, params);
    }

    if (typeof window !== 'undefined' && (window as any).fbq) {
        (window as any).fbq('track', eventName, params);
    }
};
